export { default as NotFound } from 'pages/NotFound';
